// extracted by mini-css-extract-plugin
export default {"spinnerOverlay":"Spinner_spinnerOverlay__Z4YDT","spinnerContainer":"Spinner_spinnerContainer__vzmN8","spin":"Spinner_spin__Q9zsz"};